<!-- EDIT MODE -->
<div *ngIf="editable; else previewMode">

  <!-- Header -->
  <div class="flex items-center justify-between mb-8">

    <div>



      <p class="text-sm text-gray-500 mt-1">
        {{ 'CREDIT_SECTION_RISK.SUBTITLE' | translate }}
      </p>

    </div>

    <button
      type="button"
      (click)="addRisk()"
      class="section-add-btn">

      <span class="text-lg">+</span>
      {{ 'CREDIT_SECTION.ADD_RISK' | translate }}

    </button>

  </div>

  <!-- Empty State -->
  <div
    *ngIf="activeItems.length === 0"
    class="bg-white border border-dashed border-gray-300 rounded-2xl p-12 text-center mb-6">

    <div class="text-5xl mb-3">⚠️</div>

    <h3 class="text-lg font-semibold text-gray-700">
      {{ 'CREDIT_SECTION_RISK.NO_RISKS' | translate }}
    </h3>

    <p class="text-gray-500 mt-2">
      {{ 'CREDIT_SECTION_RISK.EMPTY_HINT' | translate }}
    </p>

  </div>

  <!-- Risk Cards -->
<div cdkDropList (cdkDropListDropped)="onRiskDrop($event)">
<div
  *ngFor="let item of activeItems; let i = index"
  cdkDrag
  cdkDragLockAxis="y"
  class="section-drag-item bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden mb-6">

  <!-- Header -->
  <div
    class="flex items-center justify-between px-6 py-4 bg-gray-50 border-b">

    <div class="flex items-center gap-3">

      <app-section-drag-handle cdkDragHandle></app-section-drag-handle>

      <div
        class="w-10 h-10 rounded-xl bg-red-100 text-red-700 flex items-center justify-center font-semibold">

        {{ i + 1 }}

      </div>

      <div>

        <h3 class="font-semibold text-gray-800">
          {{ 'CREDIT_SECTION_RISK.RISK_N' | translate: { n: i + 1 } }}
        </h3>

      </div>

    </div>

    <button
      type="button"
      (click)="requestRemoveRisk(i)"
      class="section-delete-btn">

      {{ 'COMMON.DELETE' | translate }}

    </button>

  </div>

  <!-- Body -->
  <div class="p-6">

    <!-- Content: bullets come from the editor's list buttons -->
    <div>

      <label class="block text-sm font-medium text-gray-600 mb-2">
        {{ 'CREDIT_SECTION_RISK.DESCRIPTION_RESPONSE' | translate }}
      </label>

      <app-rich-text-editor
        [(ngModel)]="item.content"
        minHeight="200px"
        [placeholder]="'CREDIT_SECTION_RISK.DESCRIPTION_RESPONSE' | translate"
      ></app-rich-text-editor>

    </div>

  </div>

</div>
</div>

  <!-- Conclusion -->
  <div
    class="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

    <div class="px-6 py-4 bg-gray-50 border-b flex items-center justify-between">

      <h3 class="font-semibold text-gray-800">
        {{ 'CREDIT_SECTION_RISK.CONCLUSION' | translate }}
      </h3>

      <button
        type="button"
        (click)="requestRemoveConclusion()"
        class="section-delete-btn">

        {{ 'COMMON.DELETE' | translate }}

      </button>

    </div>

    <div class="p-6">

      <app-rich-text-editor
        [(ngModel)]="conclusion"
        minHeight="200px"
        [placeholder]="'CREDIT_SECTION_RISK.CONCLUSION_PLACEHOLDER' | translate"
      ></app-rich-text-editor>

    </div>

  </div>

</div>

<app-popup
  [(show)]="showDeletePopup"
  title="CREDIT_SECTION_RISK.DELETE_RISK"
  type="confirm"
  [message]="deleteMessage"
  confirmText="COMMON.DELETE"
  cancelText="COMMON.CANCEL"
  (confirmed)="confirmDelete()"
></app-popup>

<!-- PREVIEW MODE -->
<ng-template #previewMode>

<!-- Risks -->
<div
  *ngFor="let item of activeItems; let i = index"
  class="mb-6">

  <div
    class="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">

    <div class="flex items-center gap-3 mb-4">

      <div
        class="w-8 h-8 rounded-lg bg-red-100 text-red-700 flex items-center justify-center font-semibold">

        {{ i + 1 }}

      </div>

      <h4 class="text-lg font-semibold text-[#1E2A78]">
        {{ 'CREDIT_SECTION_RISK.RISK_N' | translate: { n: i + 1 } }}
      </h4>

    </div>

    <div class="rich-text-content text-gray-700" [innerHTML]="item.content | richText"></div>

  </div>

</div>

  <!-- Conclusion -->
  <div
    *ngIf="conclusion"
    class="bg-white rounded-xl border border-gray-200 p-6 mt-8 shadow-sm">

    <h4 class="text-xl font-semibold text-[#1E2A78] mb-4">
      {{ 'CREDIT_SECTION_RISK.CONCLUSION' | translate }}
    </h4>

    <div class="rich-text-content text-gray-700" [innerHTML]="conclusion | richText"></div>

  </div>

</ng-template>